import { render } from "./TSKSyringe.vue?vue&type=template&id=5c24a656&scoped=true"
import script from "./TSKSyringe.vue?vue&type=script&lang=js"
export * from "./TSKSyringe.vue?vue&type=script&lang=js"

import "./TSKSyringe.vue?vue&type=style&index=0&id=5c24a656&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c24a656"]])

export default __exports__